import { Component, OnInit, Input, Output,EventEmitter } from '@angular/core';
import { EChartOption, ECharts } from 'echarts';
import { debounceTime } from 'rxjs/operators';
import { fromEvent } from 'rxjs';
import { ChartResizeService } from '../../service/chart-resize.service';
import { RingPieService } from './service/ring-pie.service';



@Component({
  selector: 'bcac-ring-pie',
  templateUrl: './ring-pie.component.html',
  styleUrls: ['./ring-pie.component.scss']
})
export class RingPieComponent implements OnInit {

  constructor(
    private chartResizeService: ChartResizeService,//自适应大小
    private ringPieService: RingPieService//自适应大小
  ) { }
  chartTitleColor = '';
  chartTitle = {
    show: true,
    label: "图表标题"
  };
  customToolBox={
    show: true,
  }
  optionInit: ECharts;
  onOptionInit(ec) {
    this.optionInit = ec;
  }
  options;
  // echart配置项
  initEchart() {
    this.options = this.chartOption;
  }
  //接口区
  cardBgColor="#fff";
  fontColor="#000"
  @Input()//深色背景
  set bcacDarkMode(darkMode: boolean) {
    this.cardBgColor=this.ringPieService.getBgColor(darkMode).bgColor;
    this.fontColor=this.ringPieService.getBgColor(darkMode).fontColor;
  }
  cardPadding = "1rem";
  @Input()//小边距
  set bcacSmallMode(smallMode: boolean) {
    if (smallMode) {
      this.cardPadding = "0rem";
    }
  }
  @Input()//是否开启标题
  set bcacTitleSwitch(titleSwitch: boolean) {
    this.chartTitle.show = titleSwitch;
  }
  @Input()//标题
  set bcacTitle(title: string) {
    this.chartTitle.label = title;
  }
  @Input()//工具
  set bcacChartShowToolbox(toolboSwitch: boolean){
    this.customToolBox.show = toolboSwitch;
  }
  bcacChart={
    data:0,
    total:100,
    name:'在线',
    color:['#57ff6f','#d1ffcc']
  }
  @Input()//数值
  set bcacChartData(value:number){
    this.bcacChart.data=value;
  }
  @Input()//总数
  set bcacChartDataTotal(value:number){
    this.bcacChart.total=value;
  }
  @Input()//系列名
  set bcacChartName(value:string){
    this.bcacChart.name=value;
  }
  @Input()//颜色
  set bcacChartColor(value:string[]){
    this.bcacChart.color=value;
  }
  // 加载等待
  _bcacChartLoading: boolean = false
  @Input()
  set bcacChartLoading(loading: boolean) {
    this._bcacChartLoading = loading;
  }
  // 下拉框数据
  dataSourceSelectData = [];
  @Input()
  set bcacDataSourceList(value: any[]) {
    this.dataSourceSelectData = value;
  }
  @Output()
  bcacDataSourceSelectEmit = new EventEmitter<any>();
  dataSourceChange(e: any) {
    this.bcacDataSourceSelectEmit.emit(e);
  }
  updateOption() {
    if (this.optionInit) {
      this.optionInit.setOption(this.options, true);
    }
  }
  ngOnInit() {
  }
  chartOption = {
    title: this.ringPieService.getChartTitle(this.bcacChart),
    series: this.ringPieService.getChartSeries(this.bcacChart)
  }
  ngOnChanges(){
    // console.log("改变啦",this.bcacChart);
    this.chartOption = {
      title: this.ringPieService.getChartTitle(this.bcacChart),
      series: this.ringPieService.getChartSeries(this.bcacChart)
    }
    this.initEchart();
    this.updateOption();
    fromEvent(window, 'resize').pipe(debounceTime(200)).subscribe(() => {
      this.chartResizeService.autoResizeAdapt(this.optionInit, this.options);
    })
  }
}
